<template>
    <div class="navBox flexBox justify-content-between">
        <div class="logoBox">
            <img class="logo" src="../../assets/logo.webp" />
        </div>

        <div class="menu flexBox justify-content-between" :class="{ 'is-open': mobileMenuOpen }">
            <a :href="$i18n.locale == 'en'? 'https://www.huayan-robotics.net/':`https://www.huayan-robotics.com/`">{{ $t('menu.home') }}</a>
            <a :href="$i18n.locale == 'en'? 'https://www.huayan-robotics.net/technology':'https://www.huayan-robotics.com/technology'">{{ $t('menu.hxjs') }}</a>
            <a :href="$i18n.locale == 'en'? 'https://www.huayan-robotics.net/product-center/xiezuojiqiren':'https://www.huayan-robotics.com/product-center/xiezuojiqiren'">{{ $t('menu.cpzx') }}</a>
            <a :href="$i18n.locale == 'en'? 'https://www.huayan-robotics.net/application':'https://www.huayan-robotics.com/application'">{{ $t('menu.hyyy') }}</a>
            <a :href="$i18n.locale == 'en'? 'https://www.huayan-robotics.net/service/faq':'https://www.huayan-robotics.com/service/faq'">{{ $t('menu.fwzc') }}</a>
            <a :href="$i18n.locale == 'en'? 'https://www.huayan-robotics.net/contact':'https://www.huayan-robotics.com/cooperation'">{{ $t('menu.hzst') }}</a>
            <a :href="$i18n.locale == 'en'? 'https://www.huayan-robotics.net/about-us/about': 'https://www.huayan-robotics.com/about-us/about'">{{ $t('menu.gywm') }}</a>
            <div class="currentMenu">{{ $t('menu.tzzgx') }}</div>
        </div>

        <div class="flexBox">
            <div class="userBox flexBox justify-content-between">
                <div class="fontBold">
                    <span :style="$i18n.locale == 'cn' ? 'color:#000' : 'color:rgba(0,0,0,.3)'"
                        @click="changeLang('cn')">CN</span>
                    /
                    <span :style="$i18n.locale == 'Hant' ? 'color:#000' : 'color:rgba(0,0,0,.3)'"
                        @click="changeLang('Hant')">繁</span>
                    /
                    <span :style="$i18n.locale == 'en' ? 'color:#000' : 'color:rgba(0,0,0,.3)'"
                        @click="changeLang('en')">EN</span>
                </div>
            </div>

            <!-- 移动端菜单按钮 -->
            <div class="mobile-toggle" @click="mobileMenuOpen = !mobileMenuOpen">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            lang: 1,
            // 新增：移动端菜单开关
            mobileMenuOpen: false
        }
    },
    methods: {
        changeLang(e) {
           this.$i18n.locale = e
            if (e == 'en') {
                 document.title = 'Huayan Robotics'
            }else{
                 document.title = '华沿机器人'
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.navBox {
    padding: 0 80px;
    height: 82px;
    width: 100vw;
    font-size: 15px;
}

.menu {
    width: 60%;
    height: 100%;

    a{
        text-decoration: none;
        color: #000;
    }

    >div {
        height: 100%;
    }

    .currentMenu {
        font-weight: bold;
        line-height: 82px;
    }
}

.userBox {
    width: 292px;
    position: relative;

    span {
        cursor: pointer;
    }

    .userIcon {
        width: 30px;
        height: 30px;
        margin-right: 15px;
    }

    .searchIcon {
        width: 30px;
        height: 30px;
    }
}

/* 新增：移动端菜单按钮（PC 上隐藏） */
// .mobile-toggle {
//     display: none;
// }
@media (max-width: 1200px){
    .menu{
        width: 70%;
    }
}
/* -------- 以下为移动端样式，不影响 PC -------- */
@media (max-width: 900px) {
    .navBox {
        padding: 0 16px;
        height: 256px;
        font-size: 14px;
        /* 保证在小屏上不要横向滚动 */
        width: 100%;
        box-sizing: border-box;
        border-bottom: 1px solid #000;
        padding: 0 60px;
        position: fixed;
        background: #FFF;
        z-index: 99;
    }

    .logo {
        width: 150px;
    }

    /* 显示汉堡按钮 */
    .mobile-toggle {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 82px;
        height: 65px;
        margin-left: 8px;
        cursor: pointer;
    }

    .mobile-toggle span {
        display: block;
        height: 5px;
        border-radius: 2px;
        background: #000;
    }

    /* 语言切换区域压缩一点宽度 */
    .userBox {
        width: auto;
        font-size: 12px;
        margin-right: 80px;
        font-size: 15px;
        // position: absolute;
    }

    /* 顶部只显示 logo + 语言 + 汉堡按钮，菜单下拉 */
    .menu {
        position: fixed;
        top: 256px;
        left: 0;
        width: 100vw;
        box-sizing: border-box;
        padding: 10px 16px 16px;
        background: #fff;
        // flex-direction: column;
        // align-items: flex-start;
        line-height: 40px;
        height: 100vh;
        display: none;
        z-index: 99;

    }

    .menu.is-open {
        display: block;
        /* 点击汉堡按钮后展开 */

        
    }

    .menu > a {
        width: 100%;
        height: 150px;
        margin: 50px 0;
        display: block;
    }

    .menu .currentMenu {
        border-bottom: none;
        /* 防止单项太粗，可以按需保留 */
        font-weight: bold;
    }
}
</style>
